var map = {
	"./frame-center-spec-overlay.png": 3,
	"./frame-center-spec-overlay@2x.png": 4,
	"./frame-center.png": 9,
	"./frame-center@2x.png": 10,
	"./frame.png": 61,
	"./frame@2x.png": 62
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img ^\.\/frame.*\.png$
// module id = 117
// module chunks = d-game